<template>
  <div class="page_nrkk">
    <div class="p_sclist">
      <div >
        <el-tabs class="tabList" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane  :label="`全部(${reprtList.reportList.length || 0})`" name="first"></el-tab-pane>
          <el-tab-pane  :label="`分析报告(${reprtList.analysisList.length || 0})`" name="second"></el-tab-pane>
          <el-tab-pane  :label="`错题本(${reprtList.wrongQuestionList.length || 0})`" name="third"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="bg_tishi_js02"> <i class="icon iconfont icon-jingshi"></i>为了合理利用服务器资源，生成的文件，系统只保存7天，超时后系统自动删除相关文件。</div>

      <div class="sc_xq " v-for="(item, index) in dataList" :key="item.id">
        <div class="sx_tb">
          <span class="bg" v-if="item.type == 2">分析<br>报告</span>
          <span class="ctb" v-if="item.type == 1">错题<br>本</span>
        </div>
        <div class="sx_bt">
          <div class="c1"><a href="#.html">{{ item.examName }}</a></div>

          <div class="c2">
            <span title="生成时间" v-if="item.status"><i class="icon iconfont icon-gonggong-shijian"></i>{{ item.showTime
            }}</span>
            <span title="生成时间" class="zt_red" v-if="!item.status"><img src="https://www.360ping.com/images/wx/loding.gif"
                style="width:16px; vertical-align:middle; margin-right:5px;">正在生成中...</span>
            <span title="考试类型"><i class="icon iconfont icon-wenzhang1"></i>{{ item.examType }}</span>

            <span title="科目"><i class="icon iconfont icon-zhishi"></i>{{ item.courseName }}</span>
          </div>

        </div>
        <div class="sx_bn">
          <span class="bn2" v-if="item.status == 1" @click="dowloadPdf(item.urlPath)"><i class="icon iconfont icon-xiazai1"></i> 立即下载</span>
          <span class="bnReload" v-if="item.status == 2" @click="reloadPdf(item)"><i class="icon iconfont icon-0-46"></i> 文件已失效，重新生成</span>
          <span class="bn3" v-if="!item.status">正在生成中，请稍等...</span>
        </div>
      </div>

     


    </div>

    
    <div class="pc_nosj" v-if="dataList.length==0&&showData">
      <i class="icon iconfont icon-wushuju"></i>
      <span class="wz">未查询到相关生成记录，可用<em class="link" @click="showEwmCode">手机扫码生成数据</em></span>
    </div>


    <el-dialog title="扫码查看" :visible.sync="codeVisible" class="layui-layer-dialog" width="280px">
      <div id="" class="layui-layer-content" v-loading="loading">
        <div class="tc_ma"><img :src="'data:image/png;base64,' + codeImg" v-if="codeImg"><span><i
              class="icon iconfont icon-weixin2"></i>微信扫码查看</span>
        </div>
      </div>
      <div class="layui-layer-btn layui-layer-btn-"><a class="layui-layer-btn0" @click="codeVisible = false">确认</a>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import { queryReportList,queryQrCode, addReport } from "../api/request";

export default {
  name: 'record',
  components: {},
  props: {},
  data() {
    return {
      reprtList: [],
      dataList: [],
      tabIndex: 0,
      showData:false,
      timer:null,
      codeVisible: false,
      codeImg: '',
      loading: false,
      activeName: 'first',
    };
  },
  watch: {},
  computed: {},
  beforeDestroy(){
    if(this.timer!=null){
      clearInterval(this.timer)
    }
  },
  methods: {
    handleClick(tab, event) {
        this.tabIndex = tab.index
        if(this.tabIndex == 0) {
          this.dataList = this.reprtList.reportList;
        } else if(this.tabIndex == 1) {
          this.dataList = this.reprtList.analysisList;
        } else {
          this.dataList = this.reprtList.wrongQuestionList;
        }
    },
    showEwmCode() {
      this.codeVisible = true;
      this.loading = true;
      queryQrCode({ url: 'https://www.360ping.com/mp?p=0' }).then((res) => {
        if (res.data.code == 200) {

          this.codeImg = res.data.data;
          this.loading = false;
        }
      })

    },
    getData(){
      queryReportList().then((res) => {
      if (res.data.code == 200) {
        this.reprtList = res.data.data;
        let status=false;
        this.reprtList.reportList.map((item) => {
          if (item.endTime) {
            item.showTime = this.timestampToTime(item.endTime)
          } else {
            item.showTime = '';
          }
          if(item.status==0){
            status=true;
          }
        })
        this.reprtList.analysisList.map((item) => {
          if (item.endTime) {
            item.showTime = this.timestampToTime(item.endTime)
          } else {
            item.showTime = '';
          }
        })
        this.reprtList.wrongQuestionList.map((item) => {
          if (item.endTime) {
            item.showTime = this.timestampToTime(item.endTime)
          } else {
            item.showTime = '';
          }
        })
        if(status==false){
          clearInterval(this.timer)
        }
        if(this.tabIndex == 0) {
          this.dataList = this.reprtList.reportList;
        } else if(this.tabIndex == 1) {
          this.dataList = this.reprtList.analysisList;
        } else {
          this.dataList = this.reprtList.wrongQuestionList;
        }
      }else{
        this.dataList = [];
      }
    })
    },
    dowloadPdf(url) {
      window.open(url)
    },
    reloadPdf(item) {
      let addData = {
        fggExamId: item.fggExamId,
        fggCourseId: item.fggCourseId,
        stuId: item.stuId,
        fggClassId: item.fggClassId,
        type: item.type,
        fggExamName: item.examName,
        fggCourseName: item.courseName,
        fggExamType: item.examType,
        info: item.info
      };
    addReport(addData).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: '重新生成成功！',
            type: 'success'
          });
          this.getData()
        }
      })
    },
    timestampToTime(timestamp) {
      // 时间戳为10位需*1000，时间戳为13位不需乘1000
      var date = new Date(timestamp);
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h = date.getHours().toString().padStart(2, '0') + ":";
      var m = date.getMinutes().toString().padStart(2, '0') + ":";
      var s = date.getSeconds().toString().padStart(2, '0');
      return Y + M + D + h + m + s;
    },
  },
  
  created() { },
  mounted() {
    queryReportList().then((res) => {
      if (res.data.code == 200) {
        this.reprtList = res.data.data;
        let status=false;
        this.reprtList.reportList.map((item) => {
          if (item.endTime) {
            item.showTime = this.timestampToTime(item.endTime)
          } else {
            item.showTime = '';
          }
          if(item.status==0){
            status=true;
          }
        })
        this.reprtList.analysisList.map((item) => {
          if (item.endTime) {
            item.showTime = this.timestampToTime(item.endTime)
          } else {
            item.showTime = '';
          }
        })
        this.reprtList.wrongQuestionList.map((item) => {
          if (item.endTime) {
            item.showTime = this.timestampToTime(item.endTime)
          } else {
            item.showTime = '';
          }
        })
        if(status&&this.timer==null){
         this.timer=setInterval(()=>{
            this.getData();
          },3000)
        }
        if(this.tabIndex == 0) {
          this.dataList = this.reprtList.reportList;
        } else if(this.tabIndex == 1) {
          this.dataList = this.reprtList.analysisList;
        } else {
          this.dataList = this.reprtList.wrongQuestionList;
        }
      }
      this.showData=true;
    })
  }
};
</script>
<style  scoped>
@import url("../assets/layer.css");
@import url("../assets/public_style.css");
@import url("../assets/pc_style.css");
/deep/ .el-tabs__item {
  font-size: 16px !important;
  font-weight: bold !important;
}
/deep/ .el-tabs__nav-scroll {
  padding-left: 20px;
}
.page_nrkk {
  width: 1200px;
  margin: 0px auto;
  background-color: #fff;
  margin-top: 10px;
  margin-bottom: 10px;
  min-height: 500px;
  border-radius: 5px;
  border: 1px solid #e7e7e7;
  padding-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/record.vue